import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService } from '@app/services/dialog.service';
import { MediaSharedLinkService } from '@app/services/media/media.service';
import { MediaSharedLinkType } from '@app/shared/enum/care-conne.enum';

@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {
  key = '';
  data: any = {};

  get hasData() {
    return Object.keys(this.data).length > 0;
  }

  get mediaType() {
    return this.data?.type;
  }

  get imageType() {
    return MediaSharedLinkType.IMAGE;
  }

  get videoType() {
    return MediaSharedLinkType.VIDEO;
  }

  constructor(
    private route: ActivatedRoute,
    private mediaSharedLinkService: MediaSharedLinkService,
    private dialog: DialogService
  ) {} 

  ngOnInit(): void {
    this.key = this.route.snapshot.paramMap.get('key') || '';
    this.mediaSharedLinkService.getDataByKeyLink(this.key).then((res) => {
      this.data = res;
      if (!this.data.success) {
        this.dialog.message("指定された動画は存在しないか、すでに削除されています。");
      }
    });
  }
}
